import { call, put, select } from "redux-saga/effects";
import { addItemRequest, getItemsRequest, updateItemRequest } from "../../spItems/api";
import { ReportsQuestionaryListName, VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { setConditionSuccess, setStatusQuestionarySuccess } from "../actions";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "src/modules/spItems/sagas/updateDefaultSaga";
import { addDefaultSaga } from "src/modules/spItems/sagas/addDefaultSaga";
import { ContentTypeIdGroupRequirement, ContentTypeIdRequirement } from "../api/config";
import { getSaga } from "./itemsWatcher";
import moment from "moment";

export function* setConditionSaga({ payload }: any): Generator<any, void, unknown> {
  try {
    if (payload) {

      const { 
        Requirement, 
        Condition, 
        Subdivision, 
        GroupRequirementID, 
        GroupRequirementFileRef, 
        Month, 
        Year, 
        answer,
        FactoryID,
        FactoryTitle,

        DirectoryData,

        Title,
        ColumnID,
        ColumnTitle,
        // GroupID,
        GroupTitle,
        Status,
        Subdivisions,
        SubdivisionID,
        SubdivisionTitle
      } = payload;

      console.log('Subdivisions', Subdivisions);

      let GroupID = null;

      if(DirectoryData && DirectoryData.length > 0){
        let group = DirectoryData.filter((item: any) => item.Title == GroupTitle && item.FileRef.indexOf('/Lists/VPOColumns/'+ColumnID) >= 0);
        if(group && group.length > 0){
          GroupID = group[0].ID;
        }
      }

      console.log('GroupID', GroupID);


      let isError = false,
        isCondition = false;

      let isStatusID = false;
      let currentStatusQuestionary = null;
      let count_questionaries = 0;
      let count_yes = 0;
      let count_null = 0;
      let count_no = 0;

      let reportRegionID = false;
      let count_questionaries_subdivision = 0;
      let count_yes_subdivision = 0;
      let count_null_subdivision = 0;
      let count_no_subdivision = 0;

      let list_ids_subdivisions: any = [];

      let list_yes = [];

      console.log('DirectoryData', DirectoryData);

      if(
        DirectoryData &&
        DirectoryData.length > 0
      ){
        DirectoryData.forEach((item: any) => {
          if(item.Title == GroupTitle && item.FileRef.indexOf('/Lists/VPOColumns/'+ColumnID) >= 0){
            if(
              item &&
              item.Subdivisions &&
              item.Subdivisions.length > 0
            ){
              item.Subdivisions.forEach((subdivision: any) => {
                if(
                  subdivision &&
                  list_ids_subdivisions.indexOf(subdivision.ID) < 0
                ){
                  list_ids_subdivisions.push(subdivision.ID);
                }
              })
            }
          }
        })
      }

      // console.log('DirectoryData', DirectoryData);

      const response: any = yield call<any>(getDefaultSaga, {
        listName: VPORequirementsConditionsListName,
        filters: {
          Requirement: Requirement,
          Subdivision: Subdivision,
          Month: ''+Month,
          Year: ''+Year,
          FactoryID: ''+FactoryID,
        }
      });

      if(
        response &&
        response.items &&
        response.items.length > 0
      ){
        response.items.map((item: any) => {
          isCondition = item.ID;
      //     if(item.Condition && item.Condition.get_lookupId){
      //       if(item.Condition.get_lookupId() !== answer.ID){
      //         isError = true;
      //       }
      //     }
        })
      }

      if(!isError){
        if(isCondition){
          let response_condition: unknown = yield call<any>(getDefaultSaga, {
            listName: VPORequirementsConditionsListName,
            filters: {
              ID: isCondition,
            }
          });

          if(
            response_condition &&
            response_condition.items &&
            response_condition.items.length > 0
          ){
            yield call<any>(updateDefaultSaga, {
              listName: VPORequirementsConditionsListName,
              body: {
                ID: isCondition,
                Condition: Condition
              }
            })
          }
        } else {
          yield call<any>(addDefaultSaga, {
            listName: VPORequirementsConditionsListName,
            body: {
              Title: 'Ответ',
              Condition: Condition,
              Requirement: Requirement,
              Subdivision: Subdivision,
              GroupRequirementID: GroupRequirementID,
              GroupRequirementFileRef: GroupRequirementFileRef,
              Month: Month,
              Year: Year,
              FactoryID: FactoryID,
              FactoryTitle: FactoryTitle
            }
          })
        }
      }

      const response_setstatus: unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '' + ColumnID,
          GroupID: '' + GroupID,
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      if(
        response_setstatus &&
        response_setstatus.items &&
        response_setstatus.items.length > 0
      ){
        isStatusID = response_setstatus.items[0].ID;
        if(
          response_setstatus.items[0].Status &&
          response_setstatus.items[0].Status.get_lookupId
        ){
          currentStatusQuestionary = response_setstatus.items[0].Status.get_lookupId();
        } 
        // count_questionaries = response.items[0].CountQuestions;
      }

      let response_conditions_setstatus = {
        items: []
      }

      let response_conditions_setstatus_response: unknown = yield call<any>(getDefaultSaga, {
        listName: VPORequirementsConditionsListName,
        filters: {
          GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          FactoryID: '' + FactoryID,
          Month: '' + Month,
          Year: '' + Year
        },
      });

      if(
        response_conditions_setstatus_response &&
        response_conditions_setstatus_response.items &&
        response_conditions_setstatus_response.items.length > 0
      ){
        // Sort items by Modified date in descending order to get latest items first
        const sortedItems = (response_conditions_setstatus_response as any).items
          .sort((a: any, b: any) => new Date(b.Modified) - new Date(a.Modified));
    
        // Use Map to keep track of unique combinations and only keep the latest item
        const uniqueItemsMap = new Map<string, any>();
        
        sortedItems.forEach((item: any) => {
          // Create a unique key combining all required fields
          const uniqueKey = [
            item.Requirement?.get_lookupId?.(),
            item.Month,
            item.Year,
            item.FactoryID,
            item.Subdivision?.get_lookupId?.()
          ].join('_');
    
          // Only keep the latest item for each unique combination
          if (!uniqueItemsMap.has(uniqueKey)) {
            uniqueItemsMap.set(uniqueKey, item);
          }
        });
        
        // Convert Map values back to array
        response_conditions_setstatus.items = Array.from(uniqueItemsMap.values());
      }

      console.log('response_conditions_setstatus', {
        1: response_conditions_setstatus,
        2: response_conditions_setstatus_response
      });

      if(
        response_conditions_setstatus &&
        response_conditions_setstatus.items &&
        response_conditions_setstatus.items.length > 0
      ){

        let response_group_requirements_setstatus: unknown = yield call<any>(getDefaultSaga, {
          listName: 'VPOColumns',
          recursiveAll: true,
          contentType: 'Requirement',
          filtersType: 'and',
          filters: {
            ContentTypeId: '^' + ContentTypeIdGroupRequirement,
            FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          }
        })

        let response_requirements_setstatus: unknown = yield call<any>(getDefaultSaga, {
          listName: 'VPOColumns',
          recursiveAll: true,
          contentType: 'Requirement',
          filtersType: 'and',
          filters: {
            ContentTypeId: '^' + ContentTypeIdRequirement,
            FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
          }
        })

        let count_null_array: any = [];

        // console.log('list_ids_subdivisions', list_ids_subdivisions);

        if(
          response_conditions_setstatus &&
          response_conditions_setstatus.items &&
          response_conditions_setstatus.items.length > 0
        ){
          response_conditions_setstatus.items.forEach((item: any) => {

            let state = true;

            if(
              response_group_requirements_setstatus &&
              response_group_requirements_setstatus.items &&
              response_group_requirements_setstatus.items.length > 0
            ){
              let filter_group = response_group_requirements_setstatus.items.filter(group => item.GroupRequirementID == group.ID);


              if(
                filter_group &&
                filter_group.length > 0
              ){
                if(
                  filter_group[0].FinishDate && 
                  filter_group[0].FinishDate !== '' && 
                  moment(filter_group[0].FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY') 
                ){
                  state = false;
                }
                if(                  
                  filter_group[0].StartDate1 && 
                  filter_group[0].StartDate1 !== '' && 
                  moment(filter_group[0].StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
                ){
                  state = false;
                }
              }
            }

            if(
              response_requirements_setstatus &&
              response_requirements_setstatus.items &&
              response_requirements_setstatus.items.length > 0
            ){
              let filter_requirement = response_requirements_setstatus.items.filter(requirement => item.Requirement.get_lookupId() == requirement.ID);

              if(
                filter_requirement &&
                filter_requirement.length > 0
              ){
                if(
                  filter_requirement[0].FinishDate && 
                  filter_requirement[0].FinishDate !== '' && 
                  moment(filter_requirement[0].FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY') 
                ){
                  state = false;
                }
                if(                  
                  filter_requirement[0].StartDate1 && 
                  filter_requirement[0].StartDate1 !== '' && 
                  moment(filter_requirement[0].StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
                ){
                  state = false;
                }
              }
            }


            if (
              state &&
              item.Subdivision && 
              item.Subdivision.get_lookupValue && 
              item.Subdivision.get_lookupValue() &&
              item.Subdivision.get_lookupId &&
              item.Subdivision.get_lookupId() &&
              list_ids_subdivisions.indexOf(item.Subdivision.get_lookupId()) >= 0
            ) {
              // console.log('list_ids_subdivisions', list_ids_subdivisions, item.Subdivision.get_lookupId(), count_null_array);
              const conditionId = item.Condition.get_lookupId();
              if (conditionId === 1) {
                count_yes++;
                list_yes.push(item);
              } else if (conditionId === 2) {
                count_no++;
              } else if (conditionId === 3) {
                const uniqueKey = `${item.GroupRequirementFileRef}_${item.FactoryID}_${item.Month}_${item.Year}`;
                if(!count_null_array.some((existingItem: any) => 
                  existingItem.GroupRequirementFileRef === item.GroupRequirementFileRef &&
                  existingItem.FactoryID === item.FactoryID &&
                  existingItem.Month === item.Month &&
                  existingItem.Year === item.Year &&
                  existingItem.Subdivision === item.Subdivision.get_lookupId() &&
                  existingItem.Requirement === item.Requirement.get_lookupId()
                )) {
                  count_null_array.push({
                    ID: item.ID,
                    GroupRequirementFileRef: item.GroupRequirementFileRef,
                    FactoryID: item.FactoryID,
                    Month: item.Month,
                    Year: item.Year,
                    Subdivision: item.Subdivision.get_lookupId(),
                    Requirement: item.Requirement.get_lookupId(),
                  });
                }
              }
            }

            if (
              state &&
              item.Subdivision && 
              item.Subdivision.get_lookupValue && 
              item.Subdivision.get_lookupValue() && 
              item.Subdivision.get_lookupId &&
              item.Subdivision.get_lookupId() &&
              item.Subdivision.get_lookupId() == SubdivisionID
            ) {
              const conditionId = item.Condition.get_lookupId();
              if (conditionId === 1) {
                count_yes_subdivision++;
              } else if (conditionId === 2) {
                count_no_subdivision++;
              } else if (conditionId === 3) {
                count_null_subdivision++;
                if(item.Subdivision.get_lookupId() == 4 || item.Subdivision.get_lookupId() == '4'){
                  console.log('item', item);
                }
              }
            }
          });
        }

        count_null = count_null_array.length;

        // console.log('counts', {
        //   count_null_array,
        //   count_yes,
        //   count_no,
        //   count_null,
        //   count_yes_subdivision,
        //   count_no_subdivision,
        //   count_null_subdivision
        // })

        if(
          response_requirements_setstatus &&
          response_requirements_setstatus.items &&
          response_requirements_setstatus.items.length > 0
        ){

          let count_requirements = response_requirements_setstatus.items.filter(item => {

            let active_group = true;

            if(
              response_group_requirements_setstatus &&
              response_group_requirements_setstatus.items &&
              response_group_requirements_setstatus.items.length > 0
            ){
              let filter_group = response_group_requirements_setstatus.items.filter(group => item.FileRef.indexOf('/'+group.ID+'_.000/') >= 0);


              if(
                filter_group &&
                filter_group.length > 0
              ){
                if(
                  filter_group[0].FinishDate && 
                  filter_group[0].FinishDate !== '' && 
                  moment(filter_group[0].FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY') 
                ){
                  active_group = false;
                }
                if(                  
                  filter_group[0].StartDate1 && 
                  filter_group[0].StartDate1 !== '' && 
                  moment(filter_group[0].StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
                ){
                  active_group = false;
                }
              }
            }

            if(
              item.FinishDate && 
              item.FinishDate !== '' && 
              moment(item.FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
            ){
              active_group = false;
            }
            if(                  
              item.StartDate1 && 
              item.StartDate1 !== '' && 
              moment(item.StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
            ){
              active_group = false;
            }

            return active_group; 
          });

          count_questionaries = count_requirements.length * Subdivisions.length;

          let count_no_default = count_questionaries - count_no - count_yes - count_null;

          count_no = count_no + count_no_default;
          
        }

        // console.log({
        //   CountQuestions: count_questionaries,
        //   CountYes: count_yes,
        //   CountNull: count_null
        // })

        if(!isStatusID){

          yield call<any>(addDefaultSaga, {
            listName: VPOStatusQuestionnaireListName,
            body: {
              Title,
              Status: 1,
              ColumnID,
              ColumnTitle,
              GroupID,
              GroupTitle,
              FactoryID,
              FactoryTitle,
              Month,
              Year,
              CountQuestions: count_questionaries,
              CountYes: count_yes,
              CountNull: count_null
            }
          })
        } else {

          let response_status_questionary: unknown = yield call<any>(getDefaultSaga, {
            listName: VPOStatusQuestionnaireListName,
            filters: {
              ID: isStatusID
            },
          });

          if(
            response_status_questionary &&
            response_status_questionary.items &&
            response_status_questionary.items.length > 0
          ){

            yield call<any>(updateDefaultSaga, {
              listName: VPOStatusQuestionnaireListName,          
              body: {
                Status: currentStatusQuestionary && currentStatusQuestionary == 3 && 1 || currentStatusQuestionary,
                ID: isStatusID,
                CountYes: count_yes,
                CountNull: count_null,
                CountQuestions: count_questionaries,
              }
            })

          }

        }



        // Запись статистики да/нет для отделов

        const response_report_region: unknown = yield call<any>(getDefaultSaga, {
          listName: 'ReportRegion',
          filtersType: 'and',
          filters: {
            ColumnID: '' + ColumnID,
            GroupID: '' + GroupID,
            FactoryID: '' + FactoryID,
            SubdivisionID: '' + SubdivisionID,
            Month: '' + Month,
            Year: '' + Year
          },
        });

        if(
          response_report_region &&
          response_report_region.items &&
          response_report_region.items.length > 0
        ){
          
          reportRegionID = response_report_region.items[0].ID;

        }

        if(
          response_requirements_setstatus &&
          response_requirements_setstatus.items &&
          response_requirements_setstatus.items.length > 0
        ){

          console.log('response_requirements_setstatus', response_requirements_setstatus);

          let count_requirements_subdivision = response_requirements_setstatus.items.filter(item => {
            

            let active_group = true;

            if(
              response_group_requirements_setstatus &&
              response_group_requirements_setstatus.items &&
              response_group_requirements_setstatus.items.length > 0
            ){

              let filter_group = response_group_requirements_setstatus.items.filter(group => item.FileRef.indexOf('/'+group.ID+'_.000/') >= 0);

              if(
                filter_group &&
                filter_group.length > 0
              ){
                // console.log('filter_group', filter_group);
                if(
                  filter_group[0].FinishDate && 
                  filter_group[0].FinishDate !== '' && 
                  moment(filter_group[0].FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
                ){
                  active_group = false;
                }
                if(                  
                  filter_group[0].StartDate1 && 
                  filter_group[0].StartDate1 !== '' && 
                  moment(filter_group[0].StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
                ){
                  active_group = false;
                }
              }
            }

            if(
              item.FinishDate && 
              item.FinishDate !== '' && 
              moment(item.FinishDate, 'MM/DD/YYYY') <= moment('01/'+Month+'/'+Year, 'DD/MM/YYYY')
            ){
              active_group = false;
            }
            if(                  
              item.StartDate1 && 
              item.StartDate1 !== '' && 
              moment(item.StartDate1, 'MM/DD/YYYY') > moment('01/'+Month+'/'+Year, 'DD/MM/YYYY') 
            ){
              active_group = false;
            }

            return active_group; 
          });

          count_questionaries_subdivision = count_requirements_subdivision.length;

          let count_no_default_subdivision = count_questionaries_subdivision - count_no_subdivision - count_yes_subdivision - count_null_subdivision;

          count_no_subdivision = count_no_subdivision + count_no_default_subdivision;
          
        }

        if(!reportRegionID){

          yield call<any>(addDefaultSaga, {
            listName: 'ReportRegion',
            body: {
              Title,
              ColumnID,
              ColumnTitle,
              GroupID,
              GroupTitle,
              FactoryID,
              FactoryTitle,
              Month,
              Year,
              SubdivisionID,
              SubdivisionTitle,
              CountQuestions: count_questionaries_subdivision,
              CountYes: count_yes_subdivision,
              CountNull: count_null_subdivision
            }
          })
        } else {

          yield call<any>(getDefaultSaga, {
            listName: 'ReportRegion',
            filters: {
              ID: reportRegionID
            },
          });

          yield call<any>(updateDefaultSaga, {
            listName: 'ReportRegion',
            body: {
              ID: reportRegionID,
              CountQuestions: count_questionaries_subdivision,
              CountYes: count_yes_subdivision,
              CountNull: count_null_subdivision
            }
          })

        }    
        
      }
        
      yield call<any>(getSaga, {
        payload: {
          listName: VPORequirementsConditionsListName,
          contentType: VPORequirementsConditionsListName,
          filters: {
            GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
            Month: '' + Month,
            Year: '' + Year,
            FactoryID: ''+FactoryID,
          },
        }
      })


      yield put(setConditionSuccess({
        isError
      }))

      yield put(setStatusQuestionarySuccess())

      return response;

    }
  } catch (error) {
    console.log(error);
  }
}
